import React from 'react';
import Loader from '../assets/loader.gif';

const PageLoader = () => {
     return (
          // <div className='text-center mt-4'>

          // 	<div className='spinner-border text-primary mt-3' role='status'>
          // 		<span className='visually-hidden'>Loading...</span>
          // 	</div>
          // </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
               <img style={{ maxWidth: '150px' }} src={Loader} alt='loading' />
               {/* <div className="loader"></div> */}
          </div>
     );
};

export default PageLoader;
